import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Button from "@/components/ui/Button";
import {
  useHomePageContent,
  HOME_DEFAULTS,
} from "@/features/admin-content/hooks/usePageContent";

export default function Welcome() {
  const { data } = useHomePageContent();
  const leftImage = data?.welcome.leftImage ?? HOME_DEFAULTS.welcome.leftImage;
  const rightTopImage =
    data?.welcome.rightTopImage ?? HOME_DEFAULTS.welcome.rightTopImage;
  const rightBottomImage =
    data?.welcome.rightBottomImage ?? HOME_DEFAULTS.welcome.rightBottomImage;

  return (
    <section className="bg-metro-cream py-24">
      <div className="container-narrow">
        <div className="grid items-center gap-16 lg:grid-cols-2">
          <div>
            <p className="eyebrow mb-4">Welcome</p>
            <h2 className="mb-6 font-serif text-display-md text-metro-green-950">
              Enjoy Vacations
              <br />
              With Metropolis
            </h2>
            <p className="mb-8 text-base leading-relaxed text-metro-ink-muted">
              Ideally located near the iconic Dal Lake and just a short distance
              from Asia's largest Tulip Garden, Hotel Metropolis provides the
              perfect setting to explore the beauty of Srinagar. Every detail is
              thoughtfully curated — from stylish interiors to personalised
              service — ensuring a stay that is both relaxing and memorable.
            </p>
            <Link to="/about">
              <Button rightIcon={<ArrowRight size={16} />}>Read More</Button>
            </Link>
          </div>

          {/* Image grid — 2 columns on mobile, staggered on desktop */}
          <div className="grid grid-cols-2 gap-4">
            {/* Left tall image — spans 2 rows on lg, full height on mobile */}
            <div className="col-span-1 row-span-2 overflow-hidden rounded-xl lg:h-80">
              <div className="h-full min-h-[180px]">
                {leftImage && (
                  <img
                    src={leftImage}
                    alt="Suite interior"
                    loading="lazy"
                    className="h-full w-full object-cover"
                  />
                )}
              </div>
            </div>

            {/* Right top */}
            <div className="col-span-1 h-[140px] overflow-hidden rounded-xl sm:h-[150px] lg:h-[150px]">
              {rightTopImage && (
                <img
                  src={rightTopImage}
                  alt="Corridor"
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              )}
            </div>

            {/* Right bottom */}
            <div className="col-span-1 h-[140px] overflow-hidden rounded-xl sm:h-[150px] lg:h-[150px]">
              {rightBottomImage && (
                <img
                  src={rightBottomImage}
                  alt="Lounge area"
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}